import { useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";

/**
 * The VideoChannelsNav component.
 *
 * A component to navigate between /player related baseCategories
 * @returns {React.Component} Returns the VideoChannelsNav component
 */

const videoChannelOptions = [
    {
        title: "News",
        path: "news",
    },
    {
        title: "Olympics",
        path: "/sports/olympics/summer/video",
    },
    {
        title: "Paralympics",
        path: "/sports/paralympics/video",
    },
    {
        title: "Sports",
        path: "sports",
    },
    {
        title: "Arts",
        path: "arts",
    },
    {
        title: "Life",
        path: "life",
    },
    {
        title: "Archives",
        path: "archives",
    },
    {
        title: "Music",
        path: "music",
    },
    {
        title: "Docs",
        path: "docs",
    },
];

export function VideoChannelsNav() {
    const selectRef = useRef();
    const { pathname } = useLocation();
    const history = useHistory();

    const runOnPathChange = () => {
        if (
            pathname !== selectRef.current.value &&
            selectRef.current.value !== ""
        ) {
            selectRef.current.value = "";
        }
    };

    useEffect(runOnPathChange, [pathname]);

    function generateOptions() {
        return videoChannelOptions.map((item) => {
            const path = item.path.startsWith("/")
                ? item.path
                : `/player/${item.path}`;
            return (
                <option key={item.title} value={path}>
                    {item.title}
                </option>
            );
        });
    }

    function handleSelection(e) {
        e.preventDefault();
        if (!e.target && e.target.value) return;
        if (e.target.value === "") return;
        history.push(e.target.value);
    }

    return (
        <div className="player-base-category-nav" role="navigation">
            <div className="inner">
                <label
                    id="select-label"
                    className="base-category-title"
                    htmlFor={"base-categories"}
                    aria-label="Select a channel"
                >
                    Video
                </label>
                <select
                    aria-labelledby={"select-label"}
                    onBlur={handleSelection}
                    onChange={handleSelection}
                    defaultValue=""
                    name="base-categories"
                    id="base-categories"
                    ref={selectRef}
                >
                    <option value="">Channels</option>
                    <option value="/player">Home</option>
                    {generateOptions()}
                </select>
            </div>
        </div>
    );
}

export default VideoChannelsNav;
